function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import cn from 'classnames';
import { func, number, string, shape } from 'prop-types';
import Button from '../Button';
/**
 * SaveButton component.
 */

var SaveButton = function SaveButton(_ref) {
  var buttonStates = _ref.buttonStates,
      className = _ref.className,
      onClick = _ref.onClick,
      initialWait = _ref.initialWait,
      intermediateWait = _ref.intermediateWait,
      restProps = _objectWithoutProperties(_ref, ["buttonStates", "className", "onClick", "initialWait", "intermediateWait"]);

  var _useState = useState(buttonStates.default),
      _useState2 = _slicedToArray(_useState, 2),
      buttonState = _useState2[0],
      setButtonState = _useState2[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(evt) {
      var lastUpdated, newState, timer;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newState = buttonStates.saved; // Set the "saving" state if the `onClick` doesn't resolve within the `wait` time

              timer = setTimeout(function () {
                setButtonState(buttonStates.saving);
                lastUpdated = Date.now();
              }, initialWait);
              _context.prev = 2;
              _context.next = 5;
              return onClick(evt);

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              // TODO: error message to be added in future ticket
              newState = buttonStates.default;

            case 10:
              clearTimeout(timer); // Set the new state, waiting for at least the `wait` time for the case
              // where we only just switched to the saving state. If the saving state was
              // never switched to this will set the new state right away.

              setTimeout(function () {
                setButtonState(newState);
                setTimeout(function () {
                  return setButtonState(buttonStates.default);
                }, intermediateWait);
              }, intermediateWait - (Date.now() - lastUpdated) || 0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 7]]);
    }));

    return function handleClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", {
    className: cn('save-button', className)
  }, /*#__PURE__*/React.createElement(Button, _extends({
    icon: buttonState.icon,
    iconSize: 20,
    onClick: handleClick
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: 'save-button__text' + (buttonState.text !== buttonStates.default.text ? " save-button__text--saving" : "")
  }, buttonState.text)));
};

SaveButton.defaultProps = {
  className: null,
  onClick: null,
  initialWait: 200,
  intermediateWait: 1000
};
SaveButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Text and icons for the button states */
  buttonStates: shape({
    text: string,
    icon: string
  }).isRequired,

  /** Additional class names to add to the component root. */
  className: string,

  /** On click event handler - this must be an async function, otherwise the
   * switching of button states will not work as expected. */
  onClick: func,

  /** Time to wait before showing the first status change. This is useful to
   * for cases where we only want to show an intermediary "saving" state when an
   * API call, for example, takes more then `initialWait` seconds to resolve. */
  initialWait: number,

  /**
   * Minimum time to delay between changing button states. For the case
   * where we change to the "saving" state and the `onClick` resolves straight
   * after this delay prevents us flashing that intermediary state at the user
   * for too short a time.
   */
  intermediateWait: number
} : {};
export default SaveButton;